import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  deleteEntityFromLocalDBIfNeeded,
  downloadFullEntity,
} from '../../../../actions/OfflineDataActions';
import { DownloadButton } from '../../../../components/buttons/Download';
import { DOWNLOAD_ICON_ACTIONS_TYPES } from '../../../../form-designer/constants/runtime.constants';
import { getDownloadTypeForSavedSearchRow } from '../../../../form-designer/selectors/runtime.selectors';

export const DownloadCell = ({ row }) => {
  const dispatch = useDispatch();
  const entityId = `${row.ItmId}_${row.StepId}`;
  const actionType = useSelector(getDownloadTypeForSavedSearchRow(entityId, true));

  const handleDownloadClick = (type) => {
    if (type === DOWNLOAD_ICON_ACTIONS_TYPES.DOWNLOAD) {
      dispatch(downloadFullEntity(row));
      return;
    }

    dispatch(deleteEntityFromLocalDBIfNeeded(row));
  };
  return <DownloadButton actionType={actionType} onClick={handleDownloadClick} />;
};
